import { t } from "@lingui/macro";
import * as React from "react";
import { G, Rect, Circle } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const MultiSessionEventIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 15 8"
    color="currentColor"
    title={t`Multi Session Event`}
    {...props}
  >
    <G id="Group 1703">
      <Rect
        id="Rectangle 1100"
        x="1"
        y="1.5"
        width="5"
        height="5"
        rx="2.5"
        stroke="#001A19"
        strokeWidth="2"
        fill="currentColor"
      />
      <Circle id="Ellipse 308" cx="9.5" cy="4" r="1.5" fill="currentColor" />
      <Circle id="Ellipse 309" cx="13.5" cy="4" r="1.5" fill="currentColor" />
    </G>
  </Icon>
);
